import { useParams, Link } from "react-router-dom";
import characters from "../data/characters";
import "./Character.css";

const Character = () => {
  const { character } = useParams();

  const data = characters.find(c => c.id === character);

  if (!data) {
    return <h2 style={{ textAlign: "center" }}>Character not found</h2>;
  }

  return (
    <div className="character-container">
      <Link to="/7ds" className="back">⬅ Back</Link>

      <h1 className="character-name">{data.name}</h1>

      <img
        src={`/7ds/${data.id}.png`}
        alt={data.name}
        className="character-main-img"
      />

      <div className="stats-grid">
        <div className="stat-card">
          <span>Outfits – DEF</span>
          <img src={`/7ds/${data.id}_def.png`} alt="ATK" />
        </div>

        <div className="stat-card">
          <span>Weapons – ATK</span>
          <img src={`/7ds/${data.id}_atk.png`} alt="DEF" />
        </div>

        <div className="stat-card">
          <span>Cosmetics – HP</span>
          <img src={`/7ds/${data.id}_hp.png`} alt="HP" />
        </div>
      </div>
    </div>
  );
};

export default Character;
